import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async pesquisarCidades(api, parametros) {    
    parametros.operacao = 'pesquisarCidades';    
  
    let retorno = {};

    await api.santriGET('/rest/cidade', parametros, 10, true)
    .then(response => {
     retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
     retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RCidade.js